module.exports = __webpack_public_path__ + "img/radar-claire.fd0b6ce8.webp";